export default __webpack_public_path__ + "static/media/pending.e298316b.png";